import {
  Swiper,
  Autoplay,
  Scrollbar,
  Navigation,
} from "swiper/swiper-bundle.esm.js";

import "swiper/scss";
import "swiper/scss/scrollbar";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";

jQuery(($) => {
  let initialSlider = 0;
  if ($(".swiper-slides .swiper-slide").length > 0) {
    initialSlider = $(".swiper-slides .swiper-slide").length - 1;
  }

  if (window.innerWidth < 768) {
    // initialSlider = $(".swiper-slides .swiper-slide").length / 2;
    initialSlider = 0;
  }

  $(window).on("resize", () => {
    if (window.innerWidth < 768) {
      // initialSlider = $(".swiper-slides .swiper-slide").length / 2;
      initialSlider = 0;
    }
  });

  // special case for column slider init
  if ($(".column-image-slider").length > 0) {
    const columnImageSwiper = new Swiper(".swiper-slides", {
      slidesPerView: "auto",
      spaceBetween: window.innerWidth < 768 ? 10 : 12,
      centeredSlides: false,
      loop: false,
      hashNavigation: {
        watchState: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: false,
      },
    }).changeLanguageDirection(window.innerWidth < 768 ? "ltr" : "rtl");
  } else {
    const swiper = new Swiper(".swiper-slides", {
      slidesPerView: "auto",
      spaceBetween: 10,
      centeredSlides: false,
      loop: false,
      initialSlide: initialSlider,
      hashNavigation: {
        watchState: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: false,
      },
    });
  }

  let initialGallerySlider = 0;
  if ($(".swiper-gallery .swiper-slide").length > 0) {
    const totalSlides = $(".swiper-gallery .swiper-slide").length;
    initialGallerySlider = roundUp(totalSlides / 2, 1);
  }

  new Swiper(".swiper-gallery", {
    slidesPerView: 4,
    spaceBetween: 10,
    centeredSlides: true,
    initialSlide: initialGallerySlider,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      hide: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: "auto",
      },
      0: {
        slidesPerView: "auto",
      },
    },
  });

  if ($(".swiper-location .swiper-slide").length == 1) {
    $(".swiper-location .swiper-wrapper").addClass("disabled");
    $(".swiper-location .swiper-button-next-location").addClass("disabled");
    $(".swiper-location .swiper-button-prev-location").addClass("disabled");
  }

  new Swiper(".swiper-location", {
    slidesPerView: "1",
    spaceBetween: 0,
    loop: true,
    watchOverflow: true,
    hashNavigation: {
      watchState: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-location",
      prevEl: ".swiper-button-prev-location",
    },
  });

  if (window.innerWidth > 1023) {
    $(".swiper-courses-all .course-wrapper").addClass("disabled");
    $(".swiper-courses-all .swiper-scrollbar").addClass("disabled");
  }

  $(window).on("resize", () => {
    if (window.innerWidth > 1023) {
      $(".swiper-courses-all .course-wrapper").addClass("disabled");
      $(".swiper-courses-all .swiper-scrollbar").addClass("disabled");
    }
  });

  new Swiper(".swiper-courses-all", {
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: false,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      hide: false,
    },
    breakpoints: {
      1024: {
        initialSlide: 0,
      },
      0: {
        initialSlide: 1,
      },
    },
  });

  new Swiper(".swiper-courses-1", {
    slidesPerView: "1",
    spaceBetween: 0,
    loop: true,
    watchOverflow: true,
    hashNavigation: {
      watchState: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-courses-1",
      prevEl: ".swiper-button-prev-courses-1",
    },
  });

  new Swiper(".swiper-courses-2", {
    slidesPerView: "1",
    spaceBetween: 0,
    loop: true,
    watchOverflow: true,
    hashNavigation: {
      watchState: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-courses-2",
      prevEl: ".swiper-button-prev-courses-2",
    },
  });

  new Swiper(".swiper-courses-3", {
    slidesPerView: "1",
    spaceBetween: 0,
    loop: true,
    watchOverflow: true,
    hashNavigation: {
      watchState: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-courses-3",
      prevEl: ".swiper-button-prev-courses-3",
    },
  });

  new Swiper(".swiper-courses-4", {
    slidesPerView: "1",
    spaceBetween: 0,
    loop: true,
    watchOverflow: true,
    hashNavigation: {
      watchState: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-courses-4",
      prevEl: ".swiper-button-prev-courses-4",
    },
  });

  if ($(".swiper-event-gallery .swiper-slide").length == 1) {
    $(".swiper-event-gallery .swiper-wrapper").addClass("disabled");
    $(".swiper-event-gallery .swiper-button-next-event-gallery").addClass(
      "disabled",
    );
    $(".swiper-event-gallery .swiper-button-prev-event-gallery").addClass(
      "disabled",
    );
  }

  new Swiper(".swiper-event-gallery", {
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    hashNavigation: {
      watchState: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      hide: false,
    },
    navigation: {
      nextEl: ".swiper-button-next-event-gallery",
      prevEl: ".swiper-button-prev-event-gallery",
    },
  });

  if ($(".swiper-events .swiper-slide").length == 1) {
    $(".swiper-events .swiper-wrapper").addClass("disabled");
    $(".swiper-events .swiper-button-next-events").addClass("disabled");
    $(".swiper-events .swiper-button-prev-events").addClass("disabled");
  }

  new Swiper(".swiper-events", {
    slidesPerView: "auto",
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    hashNavigation: {
      watchState: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      hide: false,
    },
    navigation: {
      nextEl: ".swiper-button-next-events",
      prevEl: ".swiper-button-prev-events",
    },
  });

  if (window.innerWidth > 1023) {
    $(".swiper-careers .swiper-wrapper").addClass("disabled");
  }

  $(window).on("resize", () => {
    if (window.innerWidth > 1023) {
      $(".swiper-careers .swiper-wrapper").addClass("disabled");
    }
  });

  new Swiper(".swiper-careers", {
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: false,
    breakpoints: {
      1024: {
        initialSlide: 0,
      },
      0: {
        initialSlide: 1,
      },
    },
  });

  if (window.innerWidth > 1315) {
    if ($(".swiper-promotions .swiper-slide").length < 4) {
      $(".swiper-promotions .swiper-wrapper").addClass("disabled");
      $(".swiper-promotions .swiper-button-next").addClass("disabled");
      $(".swiper-promotions .swiper-button-prev").addClass("disabled");
    }
  }

  $(window).on("resize", () => {
    if (window.innerWidth > 1315) {
      if ($(".swiper-promotions .swiper-slide").length < 4) {
        $(".swiper-promotions .swiper-wrapper").addClass("disabled");
        $(".swiper-promotions .swiper-button-next").addClass("disabled");
        $(".swiper-promotions .swiper-button-prev").addClass("disabled");
      }
    }
  });

  new Swiper(".swiper-promotions", {
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: false,
    breakpoints: {
      1024: {
        initialSlide: 0,
      },
      0: {
        initialSlide: 1,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next-promotions",
      prevEl: ".swiper-button-prev-promotions",
    },
  });

  function roundUp(num, precision) {
    precision = Math.pow(10, precision);
    return Math.ceil(num * precision) / precision;
  }

  new Swiper(".swiper-packages", {
    loop: false,
    longSwipes: false,
    initialSlide: 0,
    centeredSlides: true,
    spaceBetween: 0,
    slidesPerView: 3,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      hide: false,
    },
  });

  $(window).on("resize load", () => {
    if (window.innerWidth > 1023) {
      $(".swiper-packages .swiper-wrapper").addClass("disabled");
    } else {
      $(".swiper-packages .swiper-wrapper").removeClass("disabled");
    }
  });
});
